import React from 'react';
import { __ } from '@wordpress/i18n';
import { intersection, is } from 'ramda';

// store
import { useStoreValue } from '../../../../store';

// config
import { isMenuItemAllowed } from '../../../../config/routeAccessControl';

// components
import { NavLink } from 'react-router-dom';
import HelpIcon from '../../../../icons/HelpIcon';

const AppSidebar = () => {
    const permissions = useStoreValue('getPermissions');
    const role = useStoreValue('getRole');
    const companyStatus = useStoreValue('getCompanyStatus');
    const hasCompanies = useStoreValue('hasCompanies');

    const items = [
        {
            label: __('Riepilogo', 'htr'),
            icon: 'pi pi-objects-column',
            href: '/',
            id: 1,
            enable: true
        },
        {
            label: __('Gestione moduli', 'htr'),
            icon: 'pi pi-file',
            href: '/moduli',
            id: 2,
            enable: intersection(permissions, ['MANAGE_TENDERS']).length
        },
        {
            label: __('Questionario ESG', 'htr'),
            icon: 'pi pi-file',
            href: '/imieimoduli',
            id: 3,
            enable: intersection(permissions, ['APPLY_CALLS', 'APPLY_CONFIDI_CALLS']).length
        },
        {
            label: __('Richieste di integrazioni', 'htr'),
            icon: 'pi pi-exclamation-circle',
            href: '/richieste-integrazioni',
            id: 25,
            // Sempre visibile al fornitore: dopo una risposta l'azienda torna in valutazione
            // e la richiesta (in attesa, poi chiusa) deve restare raggiungibile.
            enable: intersection(permissions, ['APPLY_CALLS', 'APPLY_CONFIDI_CALLS']).length
        },
        /*{
            label: __('Form', 'htr'),
            icon: 'pi pi-bookmark',
            href: '/moduli',
            id: 4,
            enable: intersection(permissions, ['VIEW_CALLS', 'VIEW_CONFIDI_CALLS']).length
        },*/
        /*{
            label: __('Form osservati', 'htr'),
            icon: 'pi pi-star',
            href: '/moduli-osservati',
            id: 5,
            enable: intersection(permissions, ['VIEW_CALLS', 'VIEW_CONFIDI_CALLS']).length
        },*/
        {
            label: __('Gestione domande', 'htr'),
            icon: 'pi pi-file',
            href: '/domande',
            id: 6,
            enable: intersection(permissions, ['VIEW_USERS', 'ASSIGED_APPLICATION']).length
        },
        {
            label: __('Aziende in valutazione', 'htr'),
            icon: 'pi pi-calendar-clock',
            href: '/fornitori',
            id: 7,
            enable: intersection(permissions, ['EVALUATE_APPLICATIONS']).length && !intersection(permissions, ['ASSIGED_APPLICATION']).length
        },
        /*{
            label: __('Domande da valutare', 'htr'),
            icon: 'pi pi-calendar-clock',
            href: '/domande',
            id: 8,
            enable: intersection(permissions, ['EVALUATE_APPLICATIONS']).length && !intersection(permissions, ['ASSIGED_APPLICATION']).length
        },*/
        {
            label: __('Moduli attivi', 'htr'),
            icon: 'pi pi-file',
            href: '/moduli',
            id: 9,
            enable: intersection(permissions, ['EVALUATE_APPLICATIONS']).length
        },
        {
            label: __('Richieste di integrazioni', 'htr'),
            icon: <HelpIcon/>,
            href: '/soccorso-istruttorio',
            id: 10,
            enable: intersection(permissions, ['EVALUATE_APPLICATIONS']).length
        },
        /*{
            label: __('Archivio domande', 'htr'),
            icon: 'pi pi-briefcase',
            href: '/domande',
            id: 10,
            enable: intersection(permissions, ['APPLY_CALLS', 'APPLY_CONFIDI_CALLS']).length
        },*/
        {
            label: __('Aziende valutate', 'htr'),
            icon: 'pi pi-briefcase',
            href: '/archivio',
            id: 11,
            enable: intersection(permissions, ['VIEW_USERS']).length
        },
        {
            label: __('Aziende valutate', 'htr'),
            icon: 'pi pi-briefcase',
            href: '/archivio',
            id: 12,
            enable: intersection(permissions, ['EVALUATE_APPLICATIONS']).length
        },
        {
            label: __('Area personale', 'htr'),
            icon: 'pi pi-calendar-clock',
            id: 17,
            enable: intersection(permissions, ['ASSIGED_APPLICATION']).length
        },
        /*{
            label: __('Domande da valutare', 'htr'),
            icon: 'pi pi-calendar-clock',
            href: '/mie-domande',
            id: 18,
            enable: intersection(permissions, ['ASSIGED_APPLICATION']).length
        },
        {
            label: __('Richieste di integrazioni', 'htr'),
            icon: <HelpIcon/>,
            href: '/mio-soccorso-istruttorio',
            id: 19,
            enable: intersection(permissions, ['ASSIGED_APPLICATION']).length
        },*/
        {
            label: __('Gestione operatori HTR', 'htr'),
            icon: 'pi pi-users',
            href: '/utenti',
            id: 13,
            enable: intersection(permissions, ['VIEW_USERS', 'MANAGE_USERS']).length
        },
        {
            label: __('Gestione fornitori', 'htr'),
            icon: 'pi pi-building',
            href: '/fornitori',
            id: 20,
            enable: intersection(permissions, ['VIEW_USERS', 'MANAGE_USERS']).length
        },
        /*{
            label: __('Configurazione', 'htr'),
            icon: 'pi pi-cog',
            href: '/configurazione',
            id: 14,
            enable: false
        },*/
        /*{
            label: __('Statistiche', 'htr'),
            icon: 'pi pi-chart-bar',
            href: '/stats',
            id: 15,
            enable: intersection(permissions, ['APPLY_CALLS', 'APPLY_CONFIDI_CALLS']).length
        },*/
        {
            label: __('Documenti', 'htr'),
            icon: 'pi pi-folder-open',
            href: '/documenti',
            id: 16,
            enable: intersection(permissions, ['APPLY_CALLS', 'APPLY_CONFIDI_CALLS']).length
        },
        {
            label: __('Comunicazioni', 'htr'),
            icon: 'pi pi-inbox',
            href: '/comunicazioni',
            id: 17,
            enable: intersection(permissions, ['APPLY_CALLS', 'APPLY_CONFIDI_CALLS']).length
        },
        {
            label: __('Assistenza', 'htr'),
            icon: 'pi pi-comments',
            href: '/assistenza',
            id: 22,
            enable: intersection(permissions, ['APPLY_CALLS', 'APPLY_CONFIDI_CALLS']).length || intersection(permissions, ['EVALUATE_APPLICATIONS']).length
        },
        {
            label: __('Log di Sistema', 'htr'),
            icon: 'pi pi-receipt',
            clickFn: () => {
            },
            id: 24,
            enable: false
        }
    ]

    return <aside>
        <ul>
            {items
                .filter(o => {
                    // Existing permission check
                    const hasPermission = o.enable;
                    // NEW: Status-based route access check
                    const hasStatusAccess = isMenuItemAllowed(o.href, companyStatus, role, hasCompanies);
                    return hasPermission && hasStatusAccess;
                })
                .map(o => <li key={o.id}>
                    {o.href
                        ? <NavLink to={o.href}>
                            {is(String, o.icon)
                                ? <i className={o.icon}></i>
                                : o.icon}
                            <span>{o.label}</span>
                        </NavLink>
                        : (o.clickFn ?
                            <button onClick={() => {
                            }}>
                                {is(String, o.icon)
                                    ? <i className={o.icon}></i>
                                    : o.icon}
                                <span>{o.label}</span>
                            </button>
                            : <div className="nonLink">
                                <span>{o.label}</span>
                            </div>)}
                </li>)}
        </ul>
    </aside>
}

export default AppSidebar;